import type { ComponentProps } from 'react';
import outlookLogo from './outlook.svg';

export const IconOutlook = (props: ComponentProps<'img'>) => (
  <img src={outlookLogo} alt="Outlook" {...props} />
);
